/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import 'react-multiple-select-dropdown-lite/dist/index.css';
import {
  BrowserRouter as Router, Link, NavLink, Route, Switch
} from 'react-router-dom';
import bitsFetch from './components/Childs/bitsFetch';
import ImportData from './pages/ImportData';
import LogTable from './pages/LogTable';
import ZohoInventory from './pages/ZohoInventory';
import logo from './resources/icons/logo.svg';
import './resources/sass/app.scss';

function App() {
  const [isAuthorized, setisAuthorized] = useState(false)
  const [wcStatus, setWcStatus] = useState({})
  const [checkingPrevInteg, setCheckingPrevInteg] = useState(false)
  const [wcInventoryConf, setWcInventoryConf] = useState({
    name: 'Zoho Inventory API',
    enabled: true,
    clientId: '',
    clientSecret: '',
    orgId: '',

    field_map: {
      inventoryCustomerFields: [{ formField: '', zohoFormField: '' }],
      inventorySalesFields: [{ formField: '', zohoFormField: '' }]
    },
    newInteg: true,
    actions: {
      inventoryCustomer: {},
      inventorySales: {
        warehouseId:'',
      }
    }
  })
  useEffect(() => {
    setCheckingPrevInteg(true)
    bitsFetch({}, 'bit_get_integration_data')
      .then(result => {
        let integDetails = JSON.parse(JSON.stringify(wcInventoryConf))
        if (result?.success) {
          if (result.data.integ.length) {
            integDetails = JSON.parse(result.data.integ[0].integration_details)
            setWcInventoryConf(integDetails)
            setisAuthorized(true)
          }
          if (result.data.wc_status) setWcStatus(result.data.wc_status)
        }
        setCheckingPrevInteg(false)
      })
  }, [])


  return (
    <Router basename={typeof bit_wc_zoho_inventory !== 'undefined' ? bit_wc_zoho_inventory.baseURL : '/'}>
      <div id="btcd-app">
        <div className="nav-wrp">
          <div className="flx">
            <div className="logo flx" title="Bit Form">
              <Link to="/" className="flx">
                <img src={logo} alt="logo" className="ml-2" />
                <span className="ml-2">Home</span>
              </Link>
            </div>
            <nav className="top-nav ml-2">
              <NavLink
                to="/import-data"
                activeClassName="app-link-active"
              >
                Import to Zoho
              </NavLink>
              <NavLink
                to="/log-table"
                activeClassName="app-link-active"
              >
                All Logs
              </NavLink>
            </nav>
          </div>
        </div>
        <Switch>
          <Route exact path="/">
            <ZohoInventory
              isAuthorized={isAuthorized}
              setisAuthorized={setisAuthorized}
              wcInventoryConf={wcInventoryConf}
              setWcInventoryConf={setWcInventoryConf}
              checkingPrevInteg={checkingPrevInteg}
            />
          </Route>
          <Route path="/import-data">
            <ImportData
              wcStatus={wcStatus}
            />
          </Route>
          <Route path="/log-table">
            <LogTable />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
